/* eslint-disable */
import { genericService } from '../_utilities/generic'
import api from '../_api'

const genericAppointmentsService = (pathname) => ({
    fetchNext24HoursAppointments() {
        return api.get(`/${pathname}/next24hrs/`)
    },
    enableLiveStream(id) {
        return api.get(`${pathname}/${id}/live_stream_enable`)
    },
    disableLiveStream(id) {
        return api.get(`${pathname}/${id}/live_stream_disable`)
    },
    fetchStreamKey(id) {
        return api.get(`${pathname}/${id}/live_stream_key/`)
    },
    fetchPlayback(id) {
        return api.get(`${pathname}/${id}/live_stream_playback_id/`)
    },
    fetchStreamStatus(id, invitation) {
        return api.get(`${pathname}/${id}/live_stream/?invitation_pk=${invitation}`)
    },
    createInvites(payload) {
        return api.post('/invitations/', payload)
    },
    patchInvites(id, payload, groupPayload, notify, authCode) {
        return api.post(`${pathname}/${id}/update_invites/?notify=${notify}`, { payload, groupPayload, authCode })
    },
    resendInvitations(id, authCode) {
        return api.post(`${pathname}/${id}/resend_invites/`, { authCode });
    },
    downloadICS(id) {
        return api.get(`${pathname}/${id}/download_ics/`);
    },
    like(payload){
        return api.post(`/productlike/`, payload);
    },
    getReportItem(appointmentId) {
        return api.get(`${pathname}/${appointmentId}/report/`);
    },
    joinChatRoom(appointmentId, clientName) {
        return api.get(`${pathname}/join_chat/${appointmentId}/${clientName}/`);
    },
    getActivity(appointmentId, payload) {
        return api.get(`${pathname}/${appointmentId}/activity/`, {
            params: payload
        })
    },
    getChat(appointmentId) {
        return api.get(`${pathname}/${appointmentId}/chat/`)
    },
    getVideoDownloadURL(appointmentId) {
        return api.get(`${pathname}/${appointmentId}/video_download_url/`)
    },
    getVideoThumbnailURL(appointmentId) {
        return api.get(`${pathname}/${appointmentId}/video_thumb_url/`)
    },
    ...genericService(pathname),
})
export default genericAppointmentsService